import { getIn, useFormikContext } from "formik";

import { IInterestIncomes } from "../../../../config/interfaces";
import { FormField, NumericInputField } from "../../../fields";

const OIInterestFromTaxRefundForm = () => {
	const { values, errors, touched, setFieldValue, handleBlur } =
		useFormikContext<IInterestIncomes>();

	return (
		<section>
			<div className="section-title-wrap">
				<h5>Interest on Income Tax Refund</h5>
			</div>
			<FormField label="Interest Amount" sm={6}>
				<>
					<NumericInputField
						showLeftIcon={true}
						name={`IncomeTaxRefundInterestAmt.${0}[1]`}
						value={values.IncomeTaxRefundInterestAmt[0][1]}
						onChange={(value) => setFieldValue(`IncomeTaxRefundInterestAmt.${0}[1]`, value)}
						onBlur={handleBlur(`IncomeTaxRefundInterestAmt.${0}[1]`)}
						isInvalid={
							Boolean(getIn(errors, `IncomeTaxRefundInterestAmt.${0}[1]`)) &&
							getIn(touched, `IncomeTaxRefundInterestAmt.${0}[1]`)
						}
						errorMsg={getIn(errors, `IncomeTaxRefundInterestAmt.${0}[1]`)}
						note="Enter the interest amount only, do not enter the entire refund amount."
					/>
				</>
			</FormField>
		</section>
	);
};

export default OIInterestFromTaxRefundForm;
